import React from "react";
import gql from "graphql-tag";
import { getPaginatedNodes } from "@components/common/utils";
import { Box, Text, Flex } from "@atoms";
import { FundsPageWithdrawalsListItem } from "../FundsPageWithdrawalsListItem";
import { FundsPageWithdrawalsListFragment_payments } from "./__generated__/FundsPageWithdrawalsListFragment";

// == Types ================================================================

interface IProps {
  withdrawalsList: FundsPageWithdrawalsListFragment_payments | null;
}

// == Constants ============================================================

FundsPageWithdrawalsList.fragments = gql`
  fragment FundsPageWithdrawalsListFragment on Campaign {
    id
    payments @include(if: $isMember) {
      edges {
        cursor
        node {
          id
          ...FundsPageWithdrawalsListItemFragment
        }
      }
    }
  }
  ${FundsPageWithdrawalsListItem.fragments}
`;

// == Component ============================================================

export default function FundsPageWithdrawalsList({ withdrawalsList }: IProps) {
  return (
    <Flex bg="white" flexDirection="column">
      <Box bg="lightBg" padding={3}>
        <Text fontSize={[1, 1, 2]}>Withdrawal History</Text>
      </Box>
      {!!withdrawalsList?.edges &&
        getPaginatedNodes(withdrawalsList.edges).map((listItem) => {
          return listItem ? (
            <FundsPageWithdrawalsListItem key={listItem.id} listItem={listItem} />
          ) : null;
        })}
    </Flex>
  );
}

// == Styles ===============================================================
